import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

export interface SessionState {
  expired: boolean;
}

const initialState: SessionState = {
  expired: false,
};

export const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    setSessionExpired: (state) => {
      state.expired = true;
    },
    resetSessionExpired: (state) => {
      state.expired = false;
    },
  },
});

export const { setSessionExpired, resetSessionExpired } = sessionSlice.actions;

export const selectSessionExpired = (state: RootState) => state.session.expired;

export default sessionSlice.reducer;
